import React from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@common_typography';
import classNames from 'classnames';
import useStyles from './style';

const Select = ({
    label = '', name = '', value = null, onChange = () => {},
    options = [], helperText = '', className = '',
    error = false, errorMessage = '', showLabel = true, ...other
}) => {
    const styles = useStyles();
    const rootClasss = classNames(styles.root, className);
    return (
        <TextField
            id={name}
            select
            label={showLabel && label}
            name={name}
            value={value}
            onChange={onChange}
            fullWidth
            InputLabelProps={{
                shrink: true,
            }}
            className={rootClasss}
            {...other}
            placeholder={helperText}
            error={error}
            helperText={error && (
                <Typography variant="span" color={error ? 'red' : 'default'}>
                    {errorMessage}
                </Typography>
            )}
            SelectProps={{
                native: true,
            }}
        >
            <option disabled selected>
                {helperText}
            </option>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </TextField>
    );
};

export default Select;
